export class NatureInterventionEntity {
    travauxPdpId!: number;
    intervention!: string;
}